'use es6';

import { createContext } from 'react';
export default /*#__PURE__*/createContext({
  setDefaultEventProperties: () => {},
  trackEvent: () => {},
  trackBeforeUnloadEvent: () => {},
  trackPageview: () => {},
  trackFilterView: () => {},
  trackInteraction: () => {},
  trackBeforeUnloadInteraction: () => {}
});